<template>
  <BaseScreen v-bind="screen">
    <BaseMenu
      :items="menuItems"
    />
  </BaseScreen>
</template>

<script>
import screenMixin from '@/mixins/screen';
import BaseMenu from '@/components/BaseMenu.vue';

export default {
  name: 'FeedbackScreen',
  mixins: [screenMixin],
  components: {
    BaseMenu,
  },
  computed: {
    title() {
      return this.$t('titles.feedback');
    },
    menuItems() {
      return [
        {
          icon: {
            name: 'spectacle',
            isPied: true,
          },
          text: this.$t('titles.aboutSpectacle'),
          action: () => this.$router.push(this.$router.options.paths.feedbackEvents),
          isSquare: true,
        },
        {
          icon: {
            name: 'theatre',
            isBright: true,
          },
          text: this.$t('titles.aboutTheatre'),
          action: () => this.$router.push(this.$router.options.paths.audioInstruction),
          isSquare: true,
        },
      ];
    },
  },
};
</script>
